import { remoteAccessPlugin } from './plugin';

export default remoteAccessPlugin;
